export default __webpack_public_path__ + "static/media/hint-snapshot.9342f79b.png";